import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import 'bootstrap/dist/css/bootstrap.min.css';
import './StudentPortal.css';

const StudentPortal = () => {
    const { sid } = useParams();
    const [studentRecords, setStudentRecords] = useState([]);
    const [studentNames, setStudentNames] = useState({
        sfname: '',
        slname: ''
    })
    const [studentCourses, setStudentCourses] = useState({});
    const [studentCerts, setStudentCerts] = useState([]);

    const getStudentRecords = () => {
        axios.get('https://lerntutors.com/react_2026_api/students/students.php?sid=' + sid)
        .then(res => res.data)
        .then(data => {
            if (data) {
                setStudentRecords(data);
                setStudentNames({
                    sfname: data[0].sfname,
                    slname: data[0].slname
                })
            }
            else {
                setStudentRecords([]);
            }
        })
    }

    const getStudentCourses = () => {
        axios.get('https://lerntutors.com/react_2026_api/students/studentcourses.php?sid=' + sid)
        .then(res => res.data)
        .then(data => data ? setStudentCourses(data) : setStudentCourses({}));
    }

    const getStudentCerts = () => {
        axios.get('https://lerntutors.com/react_2026_api/students/studentcerts.php?sid=' + sid)
        .then(res => res.data)
        .then(data => {
            if (data) {
                setStudentCerts(data);
            }
            else {
                setStudentCerts([]);
            }
        });
    }

    const printPage = () => {
        window.print();
    }

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            getStudentRecords();
            getStudentCourses();
            getStudentCerts();
        }
        return () => mounted = false;
    }, [sid]);

    return (
        <div className="lern-studentportal">
            <div className="name-id">
                <h2>{studentNames.sfname} {studentNames.slname}</h2>
                <h3>Student ID: {sid}</h3>
            </div>
            <h2 className="transcript-section">My Courses</h2>
            <div className="courses">
                {studentRecords.map((sr, i) => {
                    return (
                        <div key={i} className="course-item">
                            <p className="scourse">{studentCourses[sr.scourse]}</p>
                            <p>{sr.scat}</p>
                            <p>{sr.sstatus}</p>
                        </div>
                    )
                })}
            </div>
            <h2 className="transcript-section">My Certificates</h2>
            <div className="certs">
                {
                    studentCerts.length > 0 ?
                    <table className="table table-striped table-bordered">
                        <thead>
                            <tr><th>Course</th><th>Year</th><th>Download</th></tr>
                        </thead>
                        <tbody>
                            {studentCerts.map((sc, i) => (
                                <tr key={i}><td>{sc.scourse}</td><td>{sc.syear}</td><td><a href={`https://lerntutors.com/storage/certs/${sc.scert}`} download target="_blank" rel="noreferrer"><FontAwesomeIcon icon={faDownload} /></a></td></tr>
                            ))}
                        </tbody>
                    </table>
                    :
                    <p className="alert alert-info text-center">You are yet to be issued a certificate</p>
                }
            </div>
            <div className="transcript-print">
                <span className="print-btn" onClick={printPage}>Print Transcript</span>
            </div>
            <div className="print-footer">
                <p><strong>Lern Tutors • Student Transcript • {new Date().toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}</strong></p>
            </div>
        </div>
    )
}

export default StudentPortal;